<template>
  <div class="main-cn">
    <div class="main-bd mg20">
      <el-row class="searchSection">
          <el-form ref="form" :inline="true" :model="searcheModel">
            <el-form-item label="所属部门">
              <UserCascader
                v-model="searcheModel.branch_id"
                ref="branch"
                :isBusiness="true"
                :branch_id="parseInt(searcheModel.branch_id)"
                @change="changeBranch"
              ></UserCascader>
            </el-form-item>
            <el-form-item label="业务员">
              <UserSelect ref="user" :uid="Number(this.$route.query['user_id'])" @change="salesmanHandleChange"></UserSelect>
            </el-form-item>
            <el-form-item label="操作类型">
              <el-select size="small" v-model="searcheModel.modify_flag" placeholder="请选择">
                <el-option label="不限" value=""></el-option>
                <el-option v-for="(item, key) in flag_list" :key="key" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
              <el-date-picker
                size="small"
                v-model="searcheModel.created_at"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="操作人">
              <UserSelect ref="operate" :uid="Number(this.$route.query['operator_id'])" @change="operateHandleChange"></UserSelect>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="submitSearch"
                >搜索</el-button
              >
              <el-button @click="resetForm()" size="small">重置</el-button>
              <ExportFile 
                :url="'/api/export/sales-change-list'" 
                :params="searcheModel" 
                filename="线索操作日志" 
                buttonName="导出Excel">
              </ExportFile>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
            <el-table :data="list" border v-loading="loading">
                <el-table-column prop="id" label="ID" type="expand">
                  <template slot-scope="props">
                    <div v-if="isAllValuesEmpty(props.row.old_record) && isAllValuesEmpty(props.row.new_record)">
                    /
                    </div>
                    <div v-else>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <p>变更前</p>
                          <p v-if="isAllValuesEmpty(props.row.old_record)">/</p>
                          <p v-else>
                            <span v-for="(item, index) in props.row.old_record" :key="index">
                              <label>{{item.label}}</label> : {{item.value}} <br/>
                            </span>
                          </p>
                        </el-col>
                        <el-col :span="12">
                          <p>变更后</p>
                          <p v-if="isAllValuesEmpty(props.row.new_record)">/</p>
                          <p v-else>
                            <span v-for="(item, index) in props.row.new_record" :key="index">
                              <span v-if="!props.row.old_record[index] || props.row.old_record[index].value != item.value">
                                <i style="color: #F56C6C;"><label>{{item.label}}</label> : {{item.value}}</i> <br/>
                              </span>
                              <span v-else>
                                <label>{{item.label}}</label> : {{item.value}} <br/>
                              </span>
                            </span>
                          </p>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" label="操作时间"></el-table-column>
                <el-table-column prop="sales_leads_id" label="线索ID"></el-table-column>
                <el-table-column prop="operator_name" label="操作人"></el-table-column>
                <el-table-column prop="flag_name" label="操作类型"></el-table-column>
                <el-table-column prop="user_name" label="绑定业务员"></el-table-column>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </el-row>
    </div>
  </div>
</template>
<style scoped>
  .grid-content {
    min-height: 40px;
    background: #81d3f8;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    color: #02A7F0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-divider--horizontal {
    margin: 0 0;
  }
  .el-divider {
    background-color: #02a7f0;
    }
</style>
<script>
import SaleClues from "~/services/SaleClues";
import UserCascader from "~/widgets/UserCascader.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ChannelCascader from "~/widgets/ChannelCascader.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import ExportFile from "~/widgets/ExportFile.vue";
import Config from "~/config/params";

export default {
  name: "logs",

  components: {
    UserSelect,
    UserCascader,
    ChannelCascader,
    MyPagination,
    ExportFile,
  },

  props: {},

  data() {
    return {
      loading: false,
      searcheModel: {
        branch_id: "",
        user_id: "",
        created_at: Config.getDataTimes('this_month'),
        // source: "",
        operator_id: '',
        modify_flag: ''
      },
      channel: {
        pid: 0,
        id: 0,
      },
      // 分页信息
      linkPage: null,
      list: [],
      all_sales_num: 0,
      unbind_list: [],
      dialogTableVisible: false,
      flag_list: [
        {label: '创建线索', value: '0'},
        {label: '绑定线索', value: '1'},
        {label: '解绑线索', value: '2'},
        {label: '删除线索', value: '3'},
        {label: '更新线索', value: '4'},
        {label: '关联客户', value: '5'},
        {label: '解绑客户', value: '6'},
        {label: '系统解绑', value: '7'},
        {label: '转交线索', value: '8'},
        {label: '分配线索', value: '9'},
        {label: '系统分配', value: '11'},
      ],
    };
  },

  mounted() {
    
  },

  created: function () {
    this.searcheModel.branch_id = this.$route.query['branch_id'] ? this.$route.query['branch_id'].toString() : '';
    this.searcheModel.user_id = this.$route.query['user_id'] ? this.$route.query['user_id'].toString() : '';
    this.searcheModel.created_at = this.$route.query['created_at'] ? this.$route.query['created_at'] : Config.getDataTimes('this_month');
    this.searcheModel.operator_id = this.$route.query['operator_id'] ? this.$route.query['operator_id'].toString() : '';
    this.searcheModel.modify_flag = this.$route.query['modify_flag'] ? this.$route.query['modify_flag'].toString() : '';
    this.getList(this.searcheModel);
  },

  methods: {
    //重置按钮
    resetForm() {
      this.searcheModel = {
        branch_id: "",
        user_id: "",
        created_at: Config.getDataTimes('this_month'),
        operator_id: '',
        modify_flag: ''
      };
      if(this.$refs['branch']){
        this.$refs['branch'].reset();
      }
      if(this.$refs['user']){
        this.$refs['user'].reset();
      }
      if(this.$refs['operate']){
        this.$refs['operate'].reset();
      }
      this.list = [];
      this.submitSearch();
    },

    // 筛选查询
    submitSearch() {
      this.getList(this.searcheModel);
    },

    //获取列表
    getList(params) {
      // loading 动画
      this.loading = true;
      SaleClues.getChangeList(params)
        .then((res) => {
            if (res.code == 0) {
                this.list = res.data;
                this.all_sales_num = _.reduce(this.list, (memo, item) => {
                        return memo + (Number(item.sales_num) || 0)
                    }, 0)
            }
            if (res._meta) {
                this.linkPage = res._meta;
            }
            this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },

    //切换部门子组件
    changeBranch(value) {
      if (value.length > 0) {
        // 取得最后一级部门作为所属部门
        this.searcheModel.branch_id = value[value.length - 1];
      } else {
        this.searcheModel.branch_id = "";
      }
    },

    //切换业务员子组件
    salesmanHandleChange(object) {
      this.searcheModel.user_id = object.label;
    },

    //切换操作人子组件
    operateHandleChange(object) {
      this.searcheModel.operator_id = object.label;
    },

    handleSizeChange(newSize) {
        // 处理每页条目数变化事件
        let params = this.searcheModel;
        params['perPage'] = newSize;
        this.getList(params);
    },

    handleCurrentChange(newPage) {
        let params = this.searcheModel;
        // 处理当前页码变化事件
        params['page'] = newPage;
        this.getList(params);
    },

    isAllValuesEmpty(list) {
      // 使用every方法判断所有value是否为空
      const allValuesEmpty = list.every(item => !item.value.trim());
      return allValuesEmpty;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/clue/logs.vue